<template>
  <svg
    viewBox="0 0 90.28 76.86"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="m26.37 63.19c.36.57 4.53 16.33 5 13.27 0-2.42-2.29-13.59-2.29-13.59z"
      fill="#692f14"
      fill-rule="evenodd"
    />
    <path
      d="m64.56 33.59-8.5-2.05-1.24 3.61.6-.1-.8 2.83 9.28-.71-4.47-2.76z"
      fill="#dc8718"
    />
    <path
      clip-rule="evenodd"
      d="m23.23 62.24c.13.66-1.62 16.87-.09 14.18.87-2.26 2.73-13.51 2.73-13.51z"
      fill="#692f14"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="m23.23 62.24c.13.66-1.62 16.87-.09 14.18.87-2.26 2.73-13.51 2.73-13.51z"
      fill="#692f14"
      fill-rule="evenodd"
    />
    <path
      d="m1.92 28.4c4.34 5.09 19.33 16.08 29.16 10.81 10.2-3.77 6.23-20.53 19.2-19.16 12.22 1.61 5.72 19.5 3.72 26.94-4 8.3-10.47 15.21-19.76 17.7-30.9 8.03-38.34-23.4-32.32-36.29z"
      fill="#ffa720"
    />
    <path
      d="m47.32 31.24c.21-.95 1.16-1.56 2.11-1.34.1.02.2.05.3.09 1.95 1.86-1.9 3.6-2.41 1.25zm-.14-2.39c3.33-2 6.13 3.29 2.36 4.84-3.54 1.07-5.1-4.23-2.36-4.84z"
      fill="#fff"
    />
    <path
      clip-rule="evenodd"
      d="m54.44 21.25 1.35-5.49c13.27.65 13.7-12.23.79-9.32.12-7-14-9.85-12.75-.49-8.95-8.79-19.62 5.13-3 8.34l1.89 7.94z"
      fill="#f8f2cf"
      fill-rule="evenodd"
    />
    <path
      d="m90.18 57.11c-.16-.83-.66-1.56-1.39-2-.47-.35-1.23-.61-2.03-.81-.05.34-.15.7-.3 1.07.02 0 .95-.23 1.07 1.28 0 0-2.45 1.75-8 1.75-8.64-.29-17.86 1.53-22.49-2.68 0-.93.81-.82 1.4-1.28s1.74.35 2.21-.94c.1-.28.23-.55.37-.82-1.65.21-3.27.66-4.79 1.37-2.32 1-2.5 2.12-1.79 3.91.01.03.03.07.05.1.16 1.16.39 2.95.67 5.4.54 4.65 6.45 4.65 8.41 5.29 1.11.44 2.13 1.08 3 1.9 0 0 2.68.74 8.59.21 1.38-.12 2.13.49 3.74-1.52s6.78-1.18 8.78-3.55a11.14 11.14 0 0 0 2.5-8.68zm-35.52.73c1.15 5.58 29.98 4.12 33.78 1.78.89-.37 1.34-.77 1.48-1.17.74 5.04-37.19 5.52-35.26-.61zm0-1.96c1.15 5.58 29.98 4.12 33.78 1.78.89-.37 1.34-.77 1.48-1.17.74 5.04-37.2 5.52-35.26-.61z"
      fill="#f8f2cf"
    />
    <path
      d="m88.44 59.62c-3.8 2.34-32.63 3.8-33.78-1.78-1.93 6.13 36 5.65 35.26.61-.14.4-.59.8-1.48 1.17z"
      fill="#c7ccae"
    />
    <path
      d="m88.44 57.66c-3.8 2.34-32.63 3.8-33.78-1.78-1.94 6.13 36 5.65 35.26.61-.14.4-.59.8-1.48 1.17z"
      fill="#c7ccae"
    />
    <path
      d="m58.44 54.44c-.59.46-1.4.35-1.4 1.28 4.63 4.21 13.85 2.39 22.49 2.68 5.55 0 8-1.75 8-1.75-.12-1.51-1.05-1.28-1.07-1.28.15-.38.25-.74.3-1.07.19-1.2-.31-2.04-2.16-1.73.06-.58-1.43-2.86-2.57-2.1 0-.01 0-.01-.01-.02-.44.34-.88.54-.88.54-3.51-.41-2.4-2.52-.75-3.11-.46-.07-1.11.05-2.09.38-1-1.51-1.91-2.47-3.61-.82-2.49-1.45-3.49-.61-3.49 2.22-1.46-1.78-4.91-2.36-4.2 1.4-.02-.09-.05-.18-.09-.26a1.747 1.747 0 0 0 -2.3-.91c-1.98.7-1.06 2.11-1.75 1.52-.54-.46-1.3.3-1.84 1.27-.14.26-.27.54-.37.82-.47 1.29-1.62.48-2.21.94zm12.11 1.54c-1.05-.35-.12-1.86.58-1.16 0 0 .47 1.51-.58 1.16zm5.68 1.13c-2.09-.46-3.73-1.12-1.98-1.74v-.01c1.01-.35 2.1-.39 3.14-.12 0 0 .93 2.33-1.16 1.87zm3.76-.31c-.93-.12-1.63 1.05-1.28-1.05 0 0 2.21 1.17 1.28 1.05zm2.76-4.67c3.19 1.09-2.75 4.86-2.33 1.86.35-1.28 2.33-1.86 2.33-1.86zm-4.04-2.67s1.05 2.45 0 2.33-1.17-2.45 0-2.33zm-3.07 1.36v-.01c.17-.76.63-1.41 1.29-1.82 1.67 3.22-1.78 4.48-1.29 1.83zm-4.19.35c3.43 2.13-.31 3.04-.93 1.64 0-.59.93-1.64.93-1.64zm-1.95-1.13s.93 2.21-.47 1.63-.7-2.33.47-1.63zm-.04 3.68c.06.62-.11 1.17-.37 1.65.1.26.05.51-.2.69-.11.06-.24.1-.38.15-.43.49-.85.78-.85.78-1.03-.19-1.66-.59-2-1.1-.19-.17-.3-.39-.27-.65v-.02c-.42-2.21 3-5.13 4.07-1.5zm-4.86-3.21s1.64 1.74.59 1.86-1.98-1.75-.59-1.86z"
      fill="#ffb824"
    />
    <path
      d="m78.71 51.79c1.05.12 0-2.33 0-2.33-1.17-.12-1.05 2.21 0 2.33zm-13.52.58c1.05-.12-.59-1.86-.59-1.86-1.39.11-.46 1.98.59 1.86zm3.84-.7c1.4.58.47-1.63.47-1.63-1.17-.7-1.87 1.05-.47 1.63zm9.68 4.08c-.35 2.1.35.93 1.28 1.05s-1.28-1.05-1.28-1.05zm-8.16.23c1.05.35.58-1.16.58-1.16-.7-.7-1.63.81-.58 1.16z"
      fill="#dc7d16"
    />
    <path
      d="m76.93 48.99c-.66.41-1.12 1.06-1.29 1.82v.01c-.49 2.65 2.96 1.39 1.29-1.83zm-6.41 3.82c.62 1.4 4.36.49.93-1.64 0 0-.93 1.05-.93 1.64zm9.9 1.18c-.42 3 5.52-.77 2.33-1.86 0 0-1.98.58-2.33 1.86zm-11.53 2.07c.26-.18.3-.43.2-.69-.17.32-.37.6-.58.84.14-.05.27-.09.38-.15zm5.36-.7v.01c-1.75.62-.11 1.28 1.98 1.74s1.16-1.87 1.16-1.87a5.419 5.419 0 0 0 -3.14.12zm-8.86-.12c-.03.27.08.48.27.65-.14-.21-.23-.44-.27-.67z"
      fill="#fed749"
    />
    <path
      d="m65.39 55.22c.05.24.13.46.27.67.34.5.97.91 2 1.1 0 0 .42-.29.85-.78.21-.24.41-.52.58-.84.25-.48.43-1.03.37-1.65-1.07-3.63-4.49-.71-4.07 1.5zm15.75-4.23s.44-.2.88-.54c.51-.38 1.02-.94.91-1.61-.54-1.16-1.62-1.3-2.54-.96-1.65.59-2.76 2.7.75 3.11z"
      fill="#ff630f"
    />
    <path
      d="m47.71 30.43c-1.43 1.33 1.44 2.79 2.26 1.41 1.03-1.71-1.05-2.69-2.26-1.41z"
      fill="#060505"
    />
    <path
      d="m65.55 41.24-1.44-.09c3.98-14.6 15.11 1.1 1.44.09zm-1.44-.09-.17.4s-2.23-.5.17-.4zm-21.27 10.55 23.7-13 1 1.83-23.81 12.68c-2.18-.09-.89-1.51-.89-1.51z"
      fill="#b06e28"
    />
    <path
      clip-rule="evenodd"
      d="m70.17 38.73s.53-2.65-1.06-3.78c-4.86-2.1-4.04 7.9 1.06 3.78z"
      fill="#ff630f"
      fill-rule="evenodd"
    />
    <path
      d="m48.26 50.36c-.93-2.17-3.59-1.79-5.53-3.27-4.27-3.28-5.86-6.36-7.74-7.64-14.48-9-23.49 15.38-2.91 15.27 4.81 0 13.25-.26 17-3.35z"
      fill="#ffc72b"
    />
  </svg>
</template>
